export default __webpack_public_path__ + "static/media/fitness_happ.80a468e3.jpg";